import styled from "@emotion/styled";

export const AppContainerStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: stretch;
`;
